module.exports = __webpack_public_path__ + "img/paper2.3b490a4e.png";